import React, { Component } from 'react'
import DashboardCleanersAdminHeader from '../../Shared/DashboardCleanersAdminHeader/DashboardCleanersAdminHeader'
import * as DashboardError400Constant from './ErrorsAdminConstant'
import ReusableButton from '../../../SharedComponents/Button/Button'
import '../../../CSS/dashboard.css'

class CleanersAdminDashboardError400 extends Component {
	constructor(props) {
		super(props);
	}

	render() {
		return (
			<div>
				<DashboardCleanersAdminHeader/>
                    <div className="ErrorDashboard">
					<p>{DashboardError400Constant.Error400DashboardParagraph}</p>
				</div>
			</div>
		)
	}
}

export default CleanersAdminDashboardError400;